module.exports = __webpack_public_path__ + "img/temp-banner-about.8ac81214.jpg";